import { Link } from "react-router-dom";
import PageBanner from "./PageBanner";
import SectionHeader from "./SectionHeader";
import React from "react";
import {
  FaBarcode,
  FaMicrochip,
  FaChartLine,
  FaTv,
  FaRecycle,
} from "react-icons/fa";
import SocialMediaSidebar from "./SocialMediaSidebar";

const TermsConditions = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Terms & Conditions"
        breadcrumb={[
          { label: "Terms & Conditions", href: "/" },
          //   { label: "About Us" },
          //   { label: "Story" },
        ]}
      />

      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Terms & Conditions @ AJEEVI"
          shareUrl="https://your-site.com/smart-waste"
        />
      </div>

      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header Section */}
          <div className="mb-10">
            <h1 className="text-3xl font-bold text-black mb-2">Terms of Use</h1>
            <p className="text-lg text-black mb-4">
              <strong>Effective Date:</strong> 17-06-2025
              <br />
              <strong>Platform:</strong> SwachhAJV
              <br />
              <strong>Operated By:</strong> Ajeevi Technologies Pvt. Ltd.
            </p>
          </div>

          {/* Welcome Statement */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Welcome Statement
            </h4>
            <p className="text-black mb-4 text-lg">
              Welcome to SwatchhAJV, a digital platform developed and maintained
              by Ajeevi Technologies Pvt. Ltd. for the purpose of enabling
              smart, efficient, and citizen-centric Solid Waste Management (SWM)
              services. This application aims to transform waste management
              practices through real-time monitoring, grievance redressal,
              data-driven operations, and active public engagement.
            </p>
            <p className="text-black text-lg">
              These Terms of Use govern your access to and use of this platform,
              including any associated services, tools, interfaces, and content.
              By using this platform, you accept and agree to be legally bound
              by these terms, and any applicable laws, regulations, and
              policies.
            </p>
          </div>

          {/* Purpose of the Platform */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              1. Purpose of the Platform
            </h4>
            <p className="text-black mb-4 text-lg">
              The SwatchhAJV application serves as a comprehensive SWM
              ecosystem, intended to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                Empower citizens to report waste management issues and receive
                timely resolutions.
              </li>
              <li>
                Enable authorities to track waste vehicles and bin collection
                schedules in real-time.
              </li>
              <li>
                Facilitate analytics-based planning and resource allocation
                using collected data.
              </li>
              <li>
                Enhance accountability through transparent service tracking and
                complaint dashboards.
              </li>
              <li>
                Improve public awareness via timely announcements, service
                updates, and emergency alerts.
              </li>
              <li>
                Digitize municipal operations for better governance, automation,
                and communication.
              </li>
            </ul>
            <p className="text-black text-lg">
              The platform plays a crucial role in supporting the Smart Cities
              Mission, Swachh Bharat Abhiyan, and other digital sanitation
              initiatives in India.
            </p>
          </div>

          {/* Eligibility and Access */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              2. Eligibility and Access
            </h4>
            <p className="text-black mb-4 text-lg">
              Access to the platform is permitted only to eligible users:
            </p>

            <h5 className="text-xl font-semibold mb-3 text-black">
              2.1 Authorized Users
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                Citizens of India, residing within the service boundaries of
                partnered Urban Local Bodies (ULBs) or municipalities.
              </li>
              <li>
                Government officials involved in SWM operations and monitoring.
              </li>
              <li>
                Contractors and Operators officially appointed to carry out
                field activities such as waste collection, segregation, and
                transfer.
              </li>
            </ul>

            <h5 className="text-xl font-semibold mb-3 text-black">
              2.2 Restricted Users
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Individuals attempting to impersonate others.</li>
              <li>
                Users who have previously been suspended or banned for violating
                these terms.
              </li>
              <li>
                Bots, crawlers, or other automated systems not authorized by the
                administrator.
              </li>
            </ul>
            <p className="text-black text-lg">
              Use of the application by unauthorized users or for unauthorized
              purposes is strictly prohibited and may be reported to the
              appropriate authorities.
            </p>
          </div>

          {/* User Responsibilities and Conduct */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              3. User Responsibilities and Conduct
            </h4>

            <h5 className="text-xl font-semibold mb-3 text-black">
              3.1 Data Accuracy
            </h5>
            <p className="text-black mb-4 text-lg">
              Users must ensure that any data, complaint, request, or feedback
              submitted through the platform is accurate, relevant, and timely.
              False complaints, misleading information, or inappropriate uploads
              will result in account suspension and legal accountability.
            </p>

            <h5 className="text-xl font-semibold mb-3 text-black">
              3.2 Ethical Use
            </h5>
            <p className="text-black mb-2 text-lg">Users agree to:</p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                Act respectfully toward sanitation staff, officials, and other
                users.
              </li>
              <li>
                Refrain from using offensive, abusive, or discriminatory
                language.
              </li>
              <li>
                Avoid uploading images or videos that violate decency norms or
                contain harmful content.
              </li>
              <li>Use the application only for its intended civic purpose.</li>
            </ul>

            <h5 className="text-xl font-semibold mb-3 text-black">
              3.3 Security and Confidentiality
            </h5>
            <p className="text-black mb-2 text-lg">
              Users are solely responsible for:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                Securing their login credentials and avoiding unauthorized
                sharing.
              </li>
              <li>Logging out from shared or public devices after use.</li>
              <li>
                Reporting any suspicious activity or unauthorized access to the
                platform support team immediately.
              </li>
            </ul>
            <p className="text-black text-lg">
              Any misuse of administrative access or unauthorized data handling
              may result in both criminal and civil proceedings.
            </p>
          </div>

          {/* Platform Functionality and Limitations */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              4. Platform Functionality and Limitations
            </h4>
            <p className="text-black mb-4 text-lg">
              While we aim to provide a consistent and reliable user experience,
              the following limitations apply:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                <strong>Real-Time Data Lag:</strong> GPS and IoT-based tracking
                systems may experience delays depending on connectivity and
                device calibration.
              </li>
              <li>
                <strong>Device Compatibility:</strong> Some features may not be
                fully optimized for all browsers or devices, particularly
                outdated mobile systems.
              </li>
              <li>
                <strong>Notification Delivery:</strong> Alerts sent via
                SMS/email are subject to third-party network delivery success
                and may be delayed.
              </li>
            </ul>
            <p className="text-black text-lg">
              Ajeevi Technologies Pvt. Ltd. is not liable for inaccuracies
              caused by third-party hardware, network outages, or force majeure
              events.
            </p>
          </div>

          {/* Data Collection, Use, and Protection */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              5. Data Collection, Use, and Protection
            </h4>
            <p className="text-black mb-4 text-lg">
              Your privacy is a priority. We collect personal, usage, and
              technical information strictly for service improvement and
              statutory reporting.
            </p>

            <h5 className="text-xl font-semibold mb-3 text-black">
              5.1 Types of Data Collected
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                <strong>Personal identifiers:</strong> Name, phone number, email
                address
              </li>
              <li>
                <strong>Location data:</strong> GPS coordinates (for complaint
                mapping or vehicle interaction)
              </li>
              <li>
                <strong>Technical metadata:</strong> IP address, device type,
                session logs
              </li>
              <li>
                <strong>Uploaded content:</strong> Images or documents submitted
                with grievances
              </li>
            </ul>

            <h5 className="text-xl font-semibold mb-3 text-black">
              5.2 Data Usage
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Service optimization, complaint routing, and analytics</li>
              <li>
                Public reporting (anonymized) to measure sanitation impact
              </li>
              <li>Audit trails for service improvement and transparency</li>
              <li>Legal compliance as mandated by local/state regulations</li>
            </ul>

            <h5 className="text-xl font-semibold mb-3 text-black">
              5.3 Data Protection
            </h5>
            <p className="text-black mb-2 text-lg">We employ:</p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>SSL encryption</li>
              <li>Secure database storage</li>
              <li>Role-based access</li>
              <li>Regular vulnerability assessments</li>
              <li>Privacy-aware architecture</li>
            </ul>
            <p className="text-black text-lg">
              We will not sell, rent, or trade your data to third parties. Your
              data may be shared with governmental authorities only if required
              under law.
            </p>
          </div>

          {/* Acceptable Use Policy */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              6. Acceptable Use Policy
            </h4>
            <p className="text-black mb-2 text-lg">You are prohibited from:</p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Interfering with system integrity or security</li>
              <li>
                Reverse-engineering, modifying, or creating derivative works
                from platform components
              </li>
              <li>Transmitting viruses, malware, or other harmful code</li>
              <li>
                Conducting any activity that threatens the availability or
                performance of the platform
              </li>
            </ul>
            <p className="text-black text-lg">
              Users in violation will face immediate suspension, and their
              activities may be reported to law enforcement authorities.
            </p>
          </div>

          {/* Ownership and Intellectual Property */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              7. Ownership and Intellectual Property
            </h4>
            <p className="text-black mb-4 text-lg">
              All intellectual property rights associated with SwatchhAJV,
              including but not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Source code</li>
              <li>Visual elements</li>
              <li>Data models and schemas</li>
              <li>Platform branding</li>
              <li>Analytics dashboards and reporting logic</li>
            </ul>
            <p className="text-black text-lg">
              are the exclusive property of Ajeevi Technologies Pvt. Ltd.,
              unless otherwise stated. Unauthorized copying, use, or
              redistribution is strictly prohibited and may lead to civil or
              criminal action.
            </p>
          </div>

          {/* Termination and Suspension */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              8. Termination and Suspension
            </h4>
            <p className="text-black mb-4 text-lg">
              Ajeevi Technologies Pvt. Ltd. reserves the right to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                Suspend user accounts that violate platform policies or show
                suspicious behavior
              </li>
              <li>
                Restrict access to features based on user type (citizen, admin,
                contractor)
              </li>
              <li>
                Delete or archive data that is malicious, abusive, or deemed
                harmful to public order
              </li>
            </ul>
            <p className="text-black text-lg">
              Repeated offenses may result in permanent blacklisting of the user
              or legal escalation.
            </p>
          </div>

          {/* Modifications and Amendments */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              9. Modifications and Amendments
            </h4>
            <p className="text-black mb-4 text-lg">
              We may revise these Terms of Use to reflect changes in:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Legal frameworks</li>
              <li>Technological advancements</li>
              <li>Service offerings or scope of work</li>
              <li>Platform architecture</li>
            </ul>
            <p className="text-black text-lg">
              When such changes occur, we will notify users via in-app
              announcements, banners, or email. Continued use of the platform
              after changes implies acceptance of the updated terms.
            </p>
          </div>

          {/* Disclaimers */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              10. Disclaimers
            </h4>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                <strong>No Warranty:</strong> The platform is provided on an
                "as-is" and "as-available" basis without warranties of any kind.
              </li>
              <li>
                <strong>No Liability:</strong> Ajeevi shall not be liable for
                any incidental, indirect, or consequential damages including
                data loss, service disruption, or user dissatisfaction.
              </li>
              <li>
                <strong>Government Contracts:</strong> Municipal bodies using
                the platform are responsible for their respective jurisdictional
                policies and service agreements.
              </li>
            </ul>
          </div>

          {/* Governing Law and Dispute Resolution */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              11. Governing Law and Dispute Resolution
            </h4>
            <p className="text-black mb-4 text-lg">
              These Terms of Use shall be governed by and construed in
              accordance with the laws of the State of Uttar Pradesh, India. Any
              disputes arising under these terms shall be exclusively subject to
              the jurisdiction of courts located in Noida, Uttar Pradesh.
            </p>
            <p className="text-black text-lg">
              In the event of any legal dispute, the user agrees to attempt
              informal resolution via the platform support team before
              initiating legal proceedings.
            </p>
          </div>

          {/* Contact Information */}
          <div>
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              12. Contact Information
            </h4>
            <p className="text-black mb-4 text-lg">
              For technical support, grievance handling, account-related
              inquiries, or legal matters, you may reach out to:
            </p>
            <p className="text-black text-lg mb-2">
              <strong>Ajeevi Technologies Pvt. Ltd.</strong>
              <br />
              505, Advant Navis Business Park, Tower A-1
              <br />
              Corporate Park, Sector 142, Noida
              <br />
              Uttar Pradesh – 201301, India
            </p>
            <p className="text-black text-lg">
              📧 Email:{" "}
              <a
                href="mailto:support@ajeevi.com"
                className="text-[#00D084] hover:underline"
              >
                support@ajeevi.com
              </a>
              <br />
              📞 Phone:{" "}
              <a
                href="tel:+919654325300"
                className="text-[#00D084] hover:underline"
              >
                +91-9654325300
              </a>
              <br />
              🌐 Website:{" "}
              <a
                href="https://swachhajv.ajeevi.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                https://swachhajv.ajeevi.in
              </a>
            </p>
            <p>Note: Terms & Conditions is subjected to changed anytime.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
